"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ColorLookup_1 = __importDefault(require("./ColorLookup"));
function default_1(colors) {
    return colors.map(function (color) {
        var colorCode;
        if (color[0] === '#') {
            colorCode = color;
        }
        else {
            colorCode = ColorLookup_1.default(color);
        }
        return colorCode;
    });
}
exports.default = default_1;
//# sourceMappingURL=chartColors.js.map